import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Option from '../../entities/option';

/*
 * Delete/nullify anywhere this option is used in other entities
 *
 * @param {Option} option
 */
export function deleteOption(option: Option, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = option.id;
    }

    /* Remove the actual option */
    option.status = 'D';
    option.addedOn = newHRTimestamp();
    option.addedBy = getCurrentUserId();
    option.importSource = targetImportSource;
    option.importId = mergeId;
    store.dispatch(Actions.OptionActions.removeOptionQueue(option));
    
}